import { render, staticRenderFns } from "./ServiceOrderBillingAndPaymentComponent.vue?vue&type=template&id=60a406b8&"
import script from "./ServiceOrderBillingAndPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderBillingAndPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports